import React from 'react';
import {Link} from 'react-router-dom';
import {RefreshButton} from './RefreshButton.js';

export const PseudoPageRefreshButton = ({...props}) => {

    return (
        <Link to={'/'}>
            <RefreshButton {...props} />
        </Link>
    );
};

